module.exports = __webpack_public_path__ + "static/media/research_4.e09fc84d.png";